import script from "./UserInfoBar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoBar.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoBar.vue?vue&type=style&index=0&id=22298f9d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22298f9d"]])

export default __exports__